import { useContext } from "react";

import { DynamicFormContext } from "containers/DynamicForm/DynamicFormContext";
import { TApiButtonCommandFn } from "containers/DynamicForm/useButtonCommand";
import { nextDynamicForm } from "store/actions/flow";
import { useAppDispatch, useAppSelector } from "store/index";

import { find } from "lodash-es";

export const useNextForm = () => {
  const dispatch = useAppDispatch();
  const flowSessionId = useAppSelector(state => state.formFlow.flowSessionId);
  const { dynamicForm, inputs } = useContext(DynamicFormContext);

  const nextFormCommand: TApiButtonCommandFn = async (commandArgs, { formAction, formScope }) => {
    const actionArgumentSource = find(commandArgs, ["name", "action"])?.source;
    const actionArgumentSourceType = find(commandArgs, ["name", "action"])?.sourceType;
    const actionValue =
      actionArgumentSourceType === "static"
        ? actionArgumentSource
        : find(inputs, ["key", actionArgumentSource])?.value;
    const criteriaAction = actionValue || formAction;

    const criteriaAttributes = {
      ...(!!criteriaAction && { action: String(criteriaAction) }),
      ...(!!formScope && { formScope }),
    };

    const retryArguments = commandArgs?.filter(argument =>
      ["retryBackoffFactor", "retryDelay", "retryTimeout"].includes(argument.name)
    );

    return await dispatch(
      nextDynamicForm({
        criteria: criteriaAttributes,
        currentFormIdentifier: dynamicForm.id,
        direction: "next",
        flowSessionId,
        retryArguments,
      })
    ).unwrap();
  };

  return nextFormCommand;
};
